<template>
  <div
    class="resource-feedback"
    @click="link('https://laihuashipin.mikecrm.com/JGBcLEd')"
  >需求反馈</div>
</template>

<script>
export default {
  methods: {
    link (url) {
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
      a.remove();
    }
  }
}
</script>

<style scoped lang="scss">
.resource-feedback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 212px;
  height: 36px;
  margin-bottom: 10px;
  background: #5778FB;
  border: 1px solid rgba(0,0,0,0);
  opacity: 1;
  border-radius: 4px;
  color: #fff;
  &:hover {
    background-color: #7d95f5;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/resourceFeedback.vue